import { useState } from "react";
import { api } from "@/lib/api";
import { toast } from "sonner";
import { Banknote, Loader2, Send, CheckCircle2, X } from "lucide-react";

const money = (v) => `$${Number(v || 0).toFixed(2)}`;

export const JobDepositCard = ({ job, onUpdated }) => {
  const [busy, setBusy] = useState(null);
  const d = job.deposit;
  const total = Number(job.final_price ?? job.approved_quote?.total ?? job.quoted_total ?? 0);
  if (job.status === "Cancelled" || (!d && (job.payment_status === "Paid" || total <= 0))) return null;

  const run = async (key, fn, ok) => {
    setBusy(key);
    try {
      const res = await fn();
      onUpdated(res.data);
      toast.success(ok);
    } catch (e) {
      toast.error(e.response?.data?.detail || "Something went wrong");
    } finally {
      setBusy(null);
    }
  };

  const request = () => {
    if (!window.confirm(`Email ${job.email} a deposit invoice for ${money(total * 0.5)} (50% of ${money(total)})?`)) return;
    run("request", () => api.post(`/admin/jobs/${job.id}/deposit/request`), "Deposit invoice emailed");
  };
  const received = () => {
    if (!window.confirm(`Mark the ${money(d.amount)} deposit as received?`)) return;
    run("received", () => api.post(`/admin/jobs/${job.id}/deposit/received`), "Deposit recorded");
  };
  const cancel = () => {
    if (!window.confirm("Cancel this deposit request? (No email is sent.)")) return;
    run("cancel", () => api.delete(`/admin/jobs/${job.id}/deposit`), "Deposit request cancelled");
  };

  return (
    <div className="surface-card p-5 sm:p-6 border-l-4 border-spark-teal" data-testid="job-deposit-card">
      <p className="label-mono text-spark-teal flex items-center gap-1.5 mb-3"><Banknote className="size-4" /> Deposit (special-order parts)</p>
      {!d ? (
        <button onClick={request} disabled={!!busy} className="btn-primary w-full text-xs" data-testid="request-deposit-btn">
          {busy === "request" ? <Loader2 className="size-4 animate-spin" /> : <Send className="size-4" />} Request 50% deposit · {money(total * 0.5)}
        </button>
      ) : d.received_at ? (
        <p className="text-sm text-emerald-700 flex items-center gap-1.5" data-testid="deposit-received-note">
          <CheckCircle2 className="size-4" /> {money(d.amount)} deposit received {new Date(d.received_at).toLocaleDateString("en-NZ")}
        </p>
      ) : (
        <div className="space-y-2.5">
          <p className="text-sm text-spark-ink" data-testid="deposit-requested-note">
            <strong>{money(d.amount)}</strong> requested {new Date(d.requested_at).toLocaleDateString("en-NZ")} · due {d.due_date}
          </p>
          <button onClick={received} disabled={!!busy} className="btn-accent w-full text-xs" data-testid="deposit-received-btn">
            {busy === "received" ? <Loader2 className="size-4 animate-spin" /> : <CheckCircle2 className="size-4" />} Deposit received
          </button>
          <div className="flex justify-between text-xs">
            <button onClick={request} disabled={!!busy} className="text-spark-teal hover:underline font-semibold" data-testid="resend-deposit-btn">Resend invoice</button>
            <button onClick={cancel} disabled={!!busy} className="text-spark-slate hover:text-red-600 inline-flex items-center gap-1" data-testid="cancel-deposit-btn"><X className="size-3" /> Cancel request</button>
          </div>
        </div>
      )}
    </div>
  );
};
